import type { ServerContext } from '@app/renderers/shell'

/** Client function to get server serialized context */
export function getServerContext() {
  return JSON.parse((window as any).__KIDSOUT_CTX) as ServerContext
}
